<template>
  <transition
    enter-active-class="duration-75 ease-out"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="duration-75 ease-in"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    @after-enter="displayModal = true"
    @after-leave="destroyModal"
  >
    <div
      v-bsl="true"
      v-if="displayShade"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-screen h-screen p-6"
    >
      <!-- Shade -->
      <div
        class="fixed inset-0 transition-opacity bg-gray-500 opacity-75"
        @click="clickOutside"
      />
      <!-- Modal -->
      <transition
        enter-active-class="duration-200 ease-out"
        enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
        leave-active-class="duration-200 ease-in"
        leave-class="translate-y-0 opacity-100 sm:scale-100"
        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
        @after-leave="displayShade = false"
      >
        <div
          v-show="displayModal"
          class="px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6 z-1000"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="text-center">
            <h2
              class="text-2xl font-bold text-center tmsk-blue-text"
              v-html="$slots.title"
            />
            <p
              class="max-w-2xl mx-auto mt-6 text-base text-center tmsk-blue-text"
              v-html="$slots.message"
            />
          </div>

          <span class="flex w-full mt-6 rounded-full shadow-sm">
            <button
              type="button"
              class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
              @click="hideAll"
            >
              <slot name="btnMessage" />
            </button>
          </span>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ErrorModal',
  components: {},
  mixins: [],
  props: {
    callback: {
      type: Function,
      required: true
    },

    clickOutsideHide: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      displayShade: false,
      displayModal: false
    }
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.displayShade = true
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    hideAll () {
      this.displayModal = false
    },

    clickOutside () {
      if (this.clickOutsideHide) this.hideAll()
    },

    destroyModal () {
      this.$destroy()
      if (this.callback) this.callback()
    }
  }
}
</script>

<style scoped>
</style>
